import { connect } from 'react-redux';

import { rejectModVersion, removeModVersion } from '../../actions/EditMod';
import { closeDialog } from '../../actions/Dialog';

import DialogConfirmationModVersionRemove
    from '../../components/Dialogs/DialogConfirmationModVersionRemove/DialogConfirmationModVersionRemove';

const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    isReject: ownProps.isReject,
})

const mapDispatchToProps = (dispatch) => ({
    onCloseDialog: () => {
        dispatch(closeDialog())
    },
    onSubmitDialog: (modVersionId) => {
        dispatch(removeModVersion(modVersionId))
        dispatch(closeDialog())
    },
    onRejectMod: (modVersionId, text, author, authorId, authorRole, type) => {
        dispatch(rejectModVersion( modVersionId, text, author, authorId, authorRole, type ))
        dispatch(closeDialog())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DialogConfirmationModVersionRemove)